import axios from '@/libs/api.request'
import config from '@/config'

const baseCloudUrl = config.basePrivateCloudUrl
const privateCloudBaseUrl = baseCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudCurrentProjectComputeQuota = (projectId, params) => {
  return axios.request({
    url: `${privateCloudBaseUrl}compute_quota/current_project/`,
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudComputeQuota = (projectId, params) => {
  return axios.request({
    url: `${privateCloudBaseUrl}compute_quota/${projectId}/`,
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const updatePrivateCloudComputeQuota = (data, projectId) => {
  return axios.request({
    url: `${privateCloudBaseUrl}compute_quota/${projectId}/`,
    needPrivateCloudProjectHeader: true,
    data: data,
    method: 'put'
  })
}
